/**
 * Invokes the callback `n` times, returning an array of the results of each invocation.
 */
export const times = <T>(n: number, callback: (index: number) => T) =>
  Array.from({ length: n }, (_, index) => callback(index));
